<form [formGroup]="materialForm"  (ngSubmit)="onSubmit()"> 
    <div class="row">                                                    
        <div class="col-md-3 pad-80 pad-right-30">                                           
            <label class="fw-bold text-dark mb-3">ADD NEW OR ENABLE
                DISABLE</label> : Material
    
            <div class="customBg mt-3">    
                <div class="row mb-2">
                    <div
                        class="col-md-4 col-xl-4 col-lg-4 col-xxl-5 align-self-center pe-0">
                        <label class="required">Material Name</label>
                    </div>
                    <div class="col-md-8 col-xl-8 col-lg-8 col-xxl-7">
                        <input type="text" class="form-control" maxlength="500"
                            id="materialName" formControlName="materialName">
                    </div>
                </div>
    
                <div class="row mb-2">
                    <div
                        class="col-md-4 col-xl-4 col-lg-4 col-xxl-5 align-self-center pe-0">
                        <label class="required">Material Type</label>
                    </div>
                    <div class="col-md-8 col-xl-8 col-lg-8 col-xxl-7">
                        <input type="text" id="materialType" formControlName="materialType" maxlength="100"
                            class="form-control">
                    </div>
                </div>
    
                <!-- <div class="row mb-2">
                    <div
                        class="col-md-4 col-xl-4 col-lg-4 col-xxl-5 align-self-center">
                        <label>Is Active</label>
                    </div>
                    <div class="col-md-8 col-xl-8 col-lg-8 col-xxl-7">
                        <input type="checkbox" class="checkbox" 
                            [checked]="true" formControlName="isActive">
                    </div>
                </div> -->
            </div>
    
            <div class="row mt-3">
                <div class="col-md-12 text-end">
                    <button class="btn progressBtn  float-end"
                        role="button">
                        <img src="assets/images/plus_icon.svg"
                            class="datePickerIcon" alt="">
                        {{buttonText}}
                    </button>
                </div>
            </div>
        </div>
        <div class="col-md-9 pad-80">
            <div class="row">
                <div class="col-md-6">
                    <label class="fw-bold text-dark mb-0">EDIT
                        EXISTING</label> : Material
                </div>
                <div class="col-md-5   position-relative">
                    <input type="text" class="form-control" formControlName="searchControl"
                    placeholder="SEARCH BY MATERIAL NAME, MATERIAL TYPE">
                    <img src="assets/images/magnifying-glass.png"
                        placeholder="Type Project Title to Filter"
                        class="searchIcon" alt="">
                </div>
                <div class="col-md-1 align-self-center text-center">
                    <div class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle urserName"
                            href="#" role="button" data-bs-toggle="dropdown"
                            aria-expanded="true">
                            <img src="assets/images/filter.png"
                                class="me-0 w-20" alt="" title="Filter">
                        </a>
                        <ul class="dropdown-menu customMargindrp"
                            data-popper-placement="bottom-end"
                            style="position: absolute; inset: 0px 0px auto auto; margin: 0px; transform: translate3d(0.8px, 24.8px, 0px);">
    
                            <div class="row mb-12px">
                                <div class="col-md-5">
                                    <label>Is Active</label>
                                </div>
                                <div class="col-md-7">
                                    <!-- <input type="checkbox" class="checkbox" 
                                        [checked]="true" formControlName="isActiveFilter"> -->
                                    <select  class="form-select border-0" aria-label="Default select example"
                                        formControlName="isActiveFilter">
                                        <option *ngFor="let item of isActiveOptions" 
                                            [value]="item.value">{{item.label}}                                                                                    
                                        </option>
                                    </select>
                                </div>
                            </div>
                                    
                            <div class="row ">
                                <div class="offset-md-3 col-md-9">
                                    <button type="button" (click)="onApplyFilter(true);"
                                        class="btn progressBtn ps-2 w-100">APPLY
                                        FILTER</button>
                                </div>
                            </div>
    
    
                        </ul>
                    </div>
                </div>
            </div>
    
            <div class="table-responsive tableFixHead mt-3" (scroll)="onScroll()">
                <table class="table datatable border-x-0 mb-0">
                    <thead>
                        <tr class="subheaderrr">
        
                            <th scope="col" class="text-start py-2" width="60%">Material Name</th>
                            <th scope="col" class="text-start py-2" width="18%">Material Type</th>
                            <th scope="col" class="text-start py-2" width="12%">Is Active</th>
                            <th scope="col" class="text-start py-2 border-end-0" width="8%">ACTION</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of filteredMaterials">
        
                            <td class="vertical-align-middle">
                                {{item.materialName}}
                            </td>
                            <td class="vertical-align-middle">
                                {{item.materialType}}
                            </td>
                            <td>
                                <div class="activeDesablebtn alignitemss">
                                    <div class="toggle-button-cover">
                                        <div class="button-cover">
                                            <div class="button b2"
                                                id="button-14">
                                                <input type="checkbox" class="checkbox" [checked]="item.isActive"
                                                    (change)="enableOrDisableMaterial($event, item)">
                                                <div class="knobs">
                                                    <span></span>
                                                </div>
                                                <div class="layer"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="vertical-align-middle text-center">
                                <img src="assets/images/pencilIocn.svg" (click)="editMaterial(item.materialID!);"
                                    title="Edit" alt="" style="cursor: pointer;">
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="card" *ngIf="filteredMaterials.length === 0 ">
                    <div class="card-body py-2 px-3">
                        <div class="emtyCard p-0">
                            <p class="mb-0">No Records Found
                            </p>
                        </div>
                    </div>
        
                </div>
            </div>
        </div>
    </div>
    
</form>